(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farsight-hero"] && !window.DesignMode) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !window.DesignMode) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panel-hero-blog"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panel-hero"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panel-image-subtitle-overlay"] && !window.DesignMode) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();
})();
